// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:focus-visible {
  outline: #ED6D05;
}

button:disabled {
  color: gray !important;
}

.login-note {
  background: #818181;
  display: inline-flex;
  align-self: center;
  text-align: center;
  align-content: center;
  justify-content: center;
  color: white;
  padding: 3px 10px;
  font-size: 14px;
  border-radius: 5px;
}

.validate-error {
  font-size: 14px;
  text-align: center;
  color: #c54545;
  padding: 5px 0 0 0;
}

._login-page {
  display: flex;
  _flex-grow: 1;
  font-family: Ubuntu;
  flex-direction: column;
  height: 1000px !important;
  overflow: visible !important;
  transform: translate(0, 50%);
}

.login-page {
  display: flex;
  _flex-grow: 1;
  font-family: Ubuntu;
  flex-direction: column;
  _height: 100%;
  _max-width: 350px;
  overflow: visible !important;
  transform: translate(0, 50%);
  position: absolute;
  width: 100%;
}

.login-frame {
  align-self: center;
  margin: 40px 15px;
  overflow: hidden;
  flex: inherit;
  max-width: 350px;
  width: calc(100% - 30px);
  transform: translate(0, -50%);
  /* position: relative; */
  /* width: 100%; */
}

._login-frame {
  align-self: center;
  margin: 0 15px;
  overflow: hidden;
  flex: inherit;
  max-width: 350px;
  width: calc(100% - 30px);
  transform: translate(0, -50%);
}

.login-header {
  padding: 15px;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  _background-color: #E7E7E7;
}
.login-header img {
  max-width: 200px;
}

.forgot-password-section {
  display: flex;
  padding: 10px 5px;
  display: flex;
  justify-content: flex-end;
}

.forgot-password {
  color: rgb(50, 50, 50) !important;
  _align-content: center;
  font-weight: bold;
  background: none;
}

.login-button {
  display: flex;
  flex-grow: 1;
  background: #ED6D05;
  margin: 15px 20px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 15px;
}

.login-container {
  display: flex;
}

.input-icon {
  position: absolute;
  right: 13px;
  top: 13px;
  font-size: 20px;
}

.login-content {
  padding: 0 15px 15px 15px;
}

.login-header-text {
  margin-bottom: 10px;
  font-size: 20px;
}

.login-field {
  _background: #E8E8E8;
  _border: none;
  position: relative;
  margin-top: 15px;
  _margin: 15px 0;
  height: 45px;
}
.login-field input {
  width: 100%;
  height: 100%;
  padding: 5px 10px;
  font-size: 16px;
  background: none;
  border: 1px solid gray;
  outline: none;
  display: flex;
  border-radius: 5px;
}
.login-field input:focus {
  border: 1px solid #ED6D05;
}

.login-footer {
  _margin-top: 100px;
  display: flex;
  flex-direction: column;
}
.login-footer .switch-button {
  margin: 10px;
  align-self: flex-end;
  display: flex;
  z-index: 999999;
  font-size: 14px;
  _font-weight: bold;
}
.login-footer .switch-text {
  color: #ED6D05;
  margin: 0 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/login-page/login-page.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,aAAA;GADA,YAEA;EACA,mBAAA;EACA,sBAAA;EACE,yBAAA;EACA,4BAAA;EACA,4BAAA;AADJ;;AAGA;EACE,aAAA;GAAA,YACA;EACA,mBAAA;EACA,sBAAA;GAAA,YACA;GAAA,gBACA;EACA,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;AAAF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,iBAAA;AACF;;AACA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;AAEF;;AAAA;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;GAGA,yBAFA;AAGF;AAFE;EACE,gBAAA;AAIJ;;AAAA;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;AAGF;;AAAA;EACE,iCAAA;GAGA,qBAFA;EACA,iBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;AAGF;;AADA;EACE,aAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,mBAAA;EACA,eAAA;AAIF;;AADA;GAIE,mBAHA;GAIA,YAHA;EACA,kBAAA;EAGA,gBAAA;GAEA,cADA;EACA,YAAA;AAEF;AADE;EACE,WAAA;EAAa,YAAA;EACb,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AAIJ;AAHI;EACE,yBAAA;AAKN;;AAAA;GAGE,iBAFA;EACA,aAAA;EACA,sBAAA;AAGF;AAFE;EACE,YAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;GAIF,iBAHE;AAIJ;AAFE;EACE,cAAA;EACA,aAAA;AAIJ","sourcesContent":["\r\ninput:focus-visible {\r\n  outline: #ED6D05;\r\n}\r\n\r\nbutton:disabled {\r\n  color: gray !important;\r\n}\r\n\r\n.login-note {\r\n  background: #818181;\r\n  display: inline-flex;\r\n  align-self: center;\r\n  text-align: center;\r\n  align-content: center;\r\n  justify-content: center;\r\n  color: white;\r\n  padding: 3px 10px;\r\n  font-size: 14px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.validate-error {\r\n  font-size: 14px;\r\n    text-align: center;\r\n    color: #c54545;\r\n    padding: 5px 0 0 0;\r\n}\r\n\r\n\r\n._login-page {\r\n  display: flex;\r\n  _flex-grow: 1;\r\n  font-family: Ubuntu;\r\n  flex-direction: column;\r\n    height: 1000px !important;\r\n    overflow: visible !important;\r\n    transform: translate(0, 50%);\r\n}\r\n.login-page {\r\n  display: flex;\r\n  _flex-grow: 1;\r\n  font-family: Ubuntu;\r\n  flex-direction: column;\r\n  _height: 100%;\r\n  _max-width: 350px;\r\n  overflow: visible !important;\r\n  transform: translate(0, 50%);\r\n  position: absolute;\r\n  width: 100%;\r\n}\r\n.login-frame {\r\n  align-self: center;\r\n  margin: 40px 15px;\r\n  overflow: hidden;\r\n  flex: inherit;\r\n  max-width: 350px;\r\n  width: calc(100% - 30px);\r\n  transform: translate(0, -50%);\r\n  /* position: relative; */\r\n  /* width: 100%; */\r\n}\r\n._login-frame {\r\n  align-self: center;\r\n  margin: 0 15px;\r\n  overflow: hidden;\r\n  flex: inherit;\r\n  max-width: 350px;\r\n  width: calc(100% - 30px);\r\n  transform: translate(0, -50%);\r\n}\r\n.login-header {\r\n  padding: 15px;\r\n  padding-top: 30px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  _background-color: #E7E7E7;\r\n  img {\r\n    max-width: 200px;\r\n  }\r\n}\r\n\r\n.forgot-password-section {\r\n  display: flex;\r\n  padding: 10px 5px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n\r\n}\r\n.forgot-password {\r\n  color: rgb(50,50,50) !important;\r\n  _align-content: center;\r\n  font-weight: bold;\r\n  background: none;\r\n}\r\n\r\n.login-button {\r\n  display: flex;\r\n  flex-grow: 1;\r\n  background: #ED6D05;\r\n  margin: 15px 20px;\r\n  border-radius: 8px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  padding: 15px;\r\n}\r\n.login-container {\r\n  display: flex;\r\n}\r\n\r\n.input-icon {\r\n  position: absolute;\r\n  right: 13px;\r\n  top: 13px;\r\n  font-size: 20px;\r\n}\r\n\r\n.login-content {\r\n  padding: 0 15px 15px 15px;\r\n}\r\n\r\n.login-header-text {\r\n  margin-bottom: 10px;\r\n  font-size: 20px;\r\n}\r\n\r\n.login-field {\r\n  _background: #E8E8E8;\r\n  _border: none;\r\n  position: relative;\r\n  \r\n  \r\n  margin-top: 15px;\r\n  _margin: 15px 0;\r\n  height: 45px;\r\n  input {\r\n    width: 100%; height: 100%;\r\n    padding: 5px 10px;\r\n    font-size: 16px;\r\n    background: none;\r\n    border: 1px solid gray;\r\n    outline: none;\r\n    display: flex;\r\n    border-radius: 5px;\r\n    &:focus {\r\n      border: 1px solid #ED6D05;\r\n    }\r\n  }\r\n}\r\n\r\n.login-footer {\r\n  _margin-top: 100px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  .switch-button {\r\n    margin: 10px;\r\n    align-self: flex-end;\r\n    display: flex;\r\n    z-index: 999999;\r\n    font-size: 14px;\r\n    _font-weight: bold;\r\n  }\r\n  .switch-text {\r\n    color: #ED6D05;\r\n    margin: 0 5px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
